/**
 * Brand marks. lucide-react ships no trademarked logos, so the six share tiles
 * carry their own single-path SVGs (currentColor, 24-box) rather than the
 * literal "IG"/"TT"/"WA" text they used to render.
 */
import type { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

const base = (props: Props) => ({
  viewBox: "0 0 24 24",
  width: 20,
  height: 20,
  fill: "currentColor",
  "aria-hidden": true,
  focusable: false as const,
  ...props,
});

export const InstagramIcon = (props: Props) => (
  <svg {...base(props)} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round">
    <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" />
    <circle cx="12" cy="12" r="4.2" />
    <circle cx="17.6" cy="6.4" r="1.1" fill="currentColor" stroke="none" />
  </svg>
);

export const TikTokIcon = (props: Props) => (
  <svg {...base(props)}>
    <path d="M16.6 2h-3.1v13.1a2.5 2.5 0 1 1-2.5-2.5c.26 0 .5.04.74.11V9.5a5.8 5.8 0 0 0-.74-.05 5.7 5.7 0 1 0 5.7 5.7V8.9a6.6 6.6 0 0 0 4 1.35V7.1a3.7 3.7 0 0 1-3.6-3.6V2z" />
  </svg>
);

export const WhatsAppIcon = (props: Props) => (
  <svg {...base(props)}>
    <path d="M12.04 2C6.6 2 2.2 6.4 2.2 11.84c0 1.94.55 3.75 1.5 5.29L2 22l5.02-1.65a9.83 9.83 0 0 0 5.02 1.36c5.43 0 9.84-4.4 9.84-9.84S17.47 2 12.04 2zm0 17.86a8.1 8.1 0 0 1-4.4-1.3l-.31-.19-3.03 1 1.02-2.94-.2-.32a8.02 8.02 0 0 1-1.24-4.27 8.16 8.16 0 1 1 8.16 8.02zm4.61-5.96c-.25-.13-1.48-.73-1.71-.81-.23-.09-.4-.13-.56.12s-.65.8-.8.96c-.14.17-.29.19-.53.06a6.6 6.6 0 0 1-1.95-1.2 7.28 7.28 0 0 1-1.34-1.68c-.14-.25-.02-.39.11-.52.12-.12.4-.44.5-.6.1-.15.05-.3-.02-.45-.06-.14-.56-1.37-.77-1.87-.2-.49-.4-.42-.56-.43h-.48c-.16 0-.42.06-.64.3-.22.25-.84.82-.84 2 0 1.19.86 2.33.98 2.49.12.16 1.7 2.7 4.14 3.68 2.03.82 2.44.66 2.88.62.44-.04 1.42-.58 1.62-1.14.2-.56.2-1.04.14-1.14-.06-.1-.23-.16-.48-.29z" />
  </svg>
);

export const XIcon = (props: Props) => (
  <svg {...base(props)}>
    <path d="M17.53 3h3.2l-6.99 7.99L21.9 21h-5.9l-4.62-6.04L6.06 21H2.85l7.35-8.4L2.4 3h6.05l4.32 5.71L17.53 3zm-1.12 16.05h1.77L7.68 4.86H5.78l10.63 14.19z" />
  </svg>
);

export const MessagesIcon = (props: Props) => (
  <svg {...base(props)} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 11.5a7.5 7.5 0 0 1-7.5 7.5c-1.1 0-2.15-.24-3.09-.66L5.5 20l1.2-3.32A7.5 7.5 0 1 1 21 11.5z" />
  </svg>
);

export const DownloadIcon = (props: Props) => (
  <svg {...base(props)} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3v11" />
    <path d="m7.5 10 4.5 4.5L16.5 10" />
    <path d="M4.5 19.5h15" />
  </svg>
);
